<div class="card full-height">
  <div class="card-header">
    <span class="card-title">Settings</span>
    <button mat-mini-fab class="closex" color="warn" (click)="close()">
      <mat-icon>close</mat-icon>
    </button>
  </div>
  <div class="card-body pt-0 rad-mon-card">
    <!-- US 6931: Each tab requires its own privilege -->
    <mat-tab-group animationDuration="0ms">
      <mat-tab label="Privileges" *ngIf="hasPrivilege(privilegeEnum.RadMonitorSettings)"
        ><rad-monitor-add-edit-privilege></rad-monitor-add-edit-privilege
      ></mat-tab>
      <mat-tab label="Location Types" *ngIf="hasPrivilege(privilegeEnum.CreateEditRadLocationType)"
        ><rad-monitor-add-edit-rad-location-type></rad-monitor-add-edit-rad-location-type
      ></mat-tab>
      <mat-tab label="Interlock" *ngIf="hasPrivilege(privilegeEnum.CreateEditRadLocationInterlock)"
        ><rad-monitor-add-edit-rad-interlock></rad-monitor-add-edit-rad-interlock
      ></mat-tab>
    </mat-tab-group>
  </div>
</div>
